"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconVote = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18,13 L17.32,13 L15.32,15 L17.23,15 L19,17 L5,17 L6.78,15 L8.83,15 L6.83,13 L6,13 L3,16 L3,22 L21,22 L21,16 L18,13 Z M19.81,7.96 L13.45,1.6 L5.68,9.36 L12.04,15.72 L19.81,7.96 Z M13.46,4.41 L17,7.95 L12.05,12.9 L8.51,9.36 L13.46,4.41 L13.46,4.41 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconVote')(IconVote);